import { Dispatch, SetStateAction } from 'react'
import { Table, TableBody, TableContainer, useMediaQuery, useTheme } from '@mui/material'

import { IChallengeWithStats } from 'src/types'
import { TableHead } from './table-head'
import { TableBodyRow } from './table-row'

interface IProps {
  data?: IChallengeWithStats[]
  sort: string
  setSort: Dispatch<SetStateAction<string>>
}

export const ConsumerChallangesTable = ({ data = [], sort, setSort }: IProps) => {
  const handleSortChange = (sortName: string) => () => {
    setSort((prevSort) =>
      prevSort.split('-')[1] === 'asc' ? `${sortName}-desc` : `${sortName}-asc`,
    )
  }
  const activeSort = sort.split('-')[0]
  const sortDirection = sort.split('-')[1] as 'desc' | 'asc'

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('laptop'))

  return (
    <>
      <TableContainer
        sx={
          isMobile
            ? {
                marginLeft: isMobile ? '-1.25rem' : 0,
                width: '100vw',
              }
            : {}
        }
      >
        <Table>
          <TableHead
            handleSortChange={handleSortChange}
            activeSort={activeSort}
            sortDirection={sortDirection}
          />
          <TableBody>
            {data?.map((row) => <TableBodyRow item={row} key={row.id} isOpen={false} />)}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
